import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-10 d-flex justify-content-end" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" ایجاد دستور ")
const _hoisted_4 = ["element-loading-text"]
const _hoisted_5 = { class: "table table-bordered table-row-dashed table-row-gray-500 table-row-bordered table-striped align-middle custom-loading-svg" }
const _hoisted_6 = { class: "text-gray-400 fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-wrap text-center" }
const _hoisted_12 = { class: "text-wrap text-center" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-wrap text-center" }
const _hoisted_15 = { class: "text-wrap text-center fw-light" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-sm btn-danger me-1" }, "حذف", -1)
const _hoisted_17 = {
  class: "d-flex justify-content-center flex-stack flex-wrap",
  dir: "ltr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: `/createAutomation/${_ctx.route.params.bot_id}/${_ctx.route.params.platform}`,
        class: "btn rounded-pill text-nowrap btn-primary d-flex flex-center ms-1 mb-3 mb-md-0 px-2 py-3 btn-hover-scale"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "w-100 h-50px",
      "element-loading-text": _ctx.translate('loading')
    }, null, 8, _hoisted_4), [
      [_directive_loading, _ctx.loading]
    ]),
    _createElementVNode("table", _hoisted_5, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_6, [
          _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.translate("نام پاسخگو")), 1),
          _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.translate("نوع")), 1),
          _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.translate("وضعیت")), 1),
          _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.translate("عملیات")), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: index,
            style: {"background":"#e5f1ff"}
          }, [
            _createElementVNode("td", _hoisted_11, _toDisplayString(item.name), 1),
            _createElementVNode("td", _hoisted_12, [
              _createElementVNode("span", null, _toDisplayString(item.enable_comment ? "کامنت" : ''), 1),
              (item.enable_direct && item.enable_comment)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, " / "))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(item.enable_direct ? "دایرکت" : ''), 1)
            ]),
            _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.translate(item.status)), 1),
            _createElementVNode("td", _hoisted_15, [
              _createVNode(_component_el_popconfirm, {
                width: "220",
                "confirm-button-text": _ctx.translate('yes'),
                "cancel-button-text": _ctx.translate('cancel'),
                "icon-color": "#626AEF",
                title: 
                        _ctx.translate(
                          'You are deleting the selected Autoresponder are you sure'
                        )
                      ,
                onConfirm: ($event: any) => (
                      _ctx.remove(item.id)
                      )
              }, {
                reference: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 2
              }, 1032, ["confirm-button-text", "cancel-button-text", "title", "onConfirm"])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      (_ctx.pagination && _ctx.pagination.total_pages > 1)
        ? (_openBlock(), _createBlock(_component_el_pagination, {
            key: 0,
            background: "",
            layout: "prev, pager, next",
            class: "mt-4 mb-4",
            total: _ctx.pagination.total,
            currentPage: _ctx.pagination.current_page,
            "page-size": _ctx.pagination.per_page,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange
          }, null, 8, ["total", "currentPage", "page-size", "onSizeChange", "onCurrentChange"]))
        : _createCommentVNode("", true)
    ])
  ]))
}